import { RefundRequestActionTypes } from '../Constants/Types';
import { RefundRequestState } from '../Interfaces/refund-interface';

const initialState: RefundRequestState = {
  refundRequests: [],
  refundRequest: null,
  lrefundRequests: false,
  lrefundRequest: false,
  pages: 0,
  total: 0
};

const RefundRequestsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case RefundRequestActionTypes.GET_REFUND_REQUESTS:
      return {
        ...state,
        refundRequests: action.payload.data,
        pages: action.payload.pages,
        total: action.payload.total,
        lrefundRequests: false
      };
    case RefundRequestActionTypes.GET_REFUND_REQUEST:
      return {
        ...state,
        refundRequest: action.payload,
        lrefundRequest: false
      };
    case RefundRequestActionTypes.UPDATE_REFUND_REQUEST:
      return {
        ...state,
        refundRequest: action.payload,
        lrefundRequest: false
      };
    case RefundRequestActionTypes.REMOVE_REFUND_REQUEST:
      return {
        ...state,
        refundRequest: null,
        lrefundRequest: false
      };
    case RefundRequestActionTypes.LOADING_REFUND_REQUESTS:
      return {
        ...state,
        lrefundRequests: true
      };
    case RefundRequestActionTypes.LOADING_REFUND_REQUEST:
      return {
        ...state,
        lrefundRequest: true
      };
    case RefundRequestActionTypes.ERROR_REFUND_REQUESTS:
      return {
        ...state,
        lrefundRequests: false
      };
    case RefundRequestActionTypes.ERROR_REFUND_REQUEST:
      return {
        ...state,
        lrefundRequest: false
      };
    default:
      return state;
  }
};

export default RefundRequestsReducer; 